let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kTnVa")).then(() => parcelRequire('jK29N'));